import React, { FC, ReactNode } from 'react';
import { SurchargeModel } from '../../../../shared/orders/product';
import { Currency } from '../../../components/Currency';
import { useTranslation } from '../../../translations';

export const SurchargeTitle: FC<{
  readonly surcharge: Pick<SurchargeModel, 'internal' | 'type'>;
}> = ({ surcharge }) => {
  const { ts } = useTranslation();
  if (surcharge.type === 'tax') {
    return ts('tax_rate');
  }

  return ts(surcharge.internal ? 'platform_fee' : 'surcharge');
};

export const surchargeRateText = (
  surcharge: Pick<SurchargeModel, 'amount' | 'amountType' | 'type'>,
): ReactNode => {
  return surcharge.type === 'tax' || surcharge.amountType === 'percent' ? (
    `${surcharge.amount / 100}%`
  ) : (
    <Currency value={surcharge.amount} />
  );
};
